export default "__VITE_ASSET__ea5bd892__"